import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EchoService {
  echo: Echo;
  private env = environment;
  // public pusher: any;
  constructor() {
    (window as any).Pusher = Pusher;
    this.echo = new Echo({
      broadcaster: 'pusher',
      key: this.env.pusherKey,
      cluster: 'ap2',
      forceTLS: true
    });
    /* (window as any).Pusher = Pusher;
    this.echo = new Echo({
    broadcaster: 'reverb',
    key: 'ryz1dfoljhqkzu39fa0j',
    wsHost: 'apidev.letstimeit.com',
    wsPort: '443',
    wssPort: '443',
    forceTLS: false,
    enabledTransports: ['ws','wss'],
});  */
    /* this.echo = new Echo({
      broadcaster: 'reverb',
      key: 'ryz1dfoljhqkzu39fa0j'
    }); */
   }
}
